import { Iconify } from "@onair/minimal-ui/iconify";
import RegisterDocumentForm, {
	RegisterDocumentFormRef,
	RegisterDocumentFormProps,
} from "./register-document-form";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	Typography,
} from "@mui/material";
import { memo, useEffect, useRef, useState } from "react";

export interface DialogRegisterDocumentProps {
	documentName?: string;
	documentDescription?: string;
	open?: boolean;
	onSubmit: RegisterDocumentFormProps["onSubmit"];
	onClose?: () => void;
}
const DialogRegisterDocument: React.FC<DialogRegisterDocumentProps> = ({
	open = false,
	documentName,
	documentDescription = "",
	onSubmit,
	onClose,
}) => {
	const documentFormRef = useRef<RegisterDocumentFormRef>(null);
	const docname = useDebounceDocname(documentName);

	return (
		<Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth scroll="body">
			<DialogTitle className="text-center border-b">
				Nhận tài liệu miễn phí
				<IconButton className="absolute right-4" onClick={onClose}>
					<Iconify
						icon="mingcute:close-line"
						width={16}
						className="text-black"
					/>
				</IconButton>
			</DialogTitle>
			<DialogContent>
				{docname && (
					<Typography component="h4" className="font-bold py-6">
						{docname}
					</Typography>
				)}

				<RegisterDocumentForm
					ref={documentFormRef}
					onSubmit={onSubmit}
					className="max-w-[460px] mx-auto"
				/>
				<div className="h-6"></div>
			</DialogContent>
			<DialogActions className="border-t">
				<Box component="div" className="flex gap-2">
					<Button variant="outlined" onClick={onClose}>
						Huỷ
					</Button>
					<Button
						variant="contained"
						className="bg-gradient-to-br from-blue-600 to-blue-700"
						onClick={documentFormRef.current?.submit}
					>
						Nhận tài liệu
					</Button>
				</Box>
			</DialogActions>
		</Dialog>
	);
};
export default memo(DialogRegisterDocument);

const useDebounceDocname = (value?: string) => {
	const [name, setName] = useState<string>();
	useEffect(() => {
		setTimeout(
			() => {
				setName(value);
			},
			name ? 300 : 0,
		);
	}, [value]);
	return name;
};
